import React, {Component} from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import {  toggleNotification } from '../../redux/reducers/view';
import { resetPathToSaveVersion, saveVersionRequest, overwriteVersionRequest, toggleSaveEditPopup } from '../../redux/reducers/savedVersions';

import Popup from '../Popup';
import SaveEditForm from '../Form/SaveEditForm';

import { commonStyles } from '../../styles/styles';
import questions from '../../assets/questions-circular.svg';
import VersionNameField from '../Form/VersionNameField';
import { Field, reduxForm } from 'redux-form';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBIcon } from 'mdbreact';
import { validateSaveEditPassword } from '../Form/validate';
import { resetSaveEditForm } from '../../redux/reducers/annotations';
import { versionStatusRequest } from '../../redux/reducers/versionStatus';
import { selectedVersion, selectedContent, getSelectedThinktool } from '../../redux/selectors';
import { xapiRequest } from '../../redux/reducers/xapi';


class SaveEditPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    this.props.resetPathToSaveVersion();
    this.props.toggleSaveEditPopup(false)
  }
  render() {
    return (
      <MDBContainer >
        <MDBModal isOpen={this.props.savedVersions.saveEditPopup} toggle={this.toggle}  centered  >

          <MDBModalHeader style={{textAlign:'left', margin: 5}} className="default-color text-white" toggle={this.toggle}><div style={{color: '#ffffff !important'}}>SAVE INSTANCE</div> </MDBModalHeader>
          <form onSubmit={this.props.handleSubmit(this.props.handleSaveEdit)}>
          <MDBModalBody>
          <div className="mb-2 mt-2">
            Would you like to save this instance?
          </div>

   
    <Field name="versionName" component={VersionNameField} />
    {this.props.savedVersions.error && (
      <div style={{margin:5}}><MDBAlert color="danger" dismiss >
      <MDBIcon icon="exclamation-circle" /><strong> Error! </strong> {this.props.savedVersions.error.message}
      </MDBAlert>
      </div>
     
    )}
  
          </MDBModalBody>
          <MDBModalFooter>
          <MDBBtn
            className="btn-dark-green"
            size='sm'
            type="submit"
            >
            SAVE
            </MDBBtn>
            {(this.props.version && this.props.userProgramsFull.selectedUserVersion !== null  && this.props.version.status!='reviewed') && (
            <MDBBtn
              size='sm'
              disabled={this.props.submitting}
              onClick={() => this.props.handleOverwrite()}
              color='secondary'
            >
              OVERWRITE
            </MDBBtn>
            )}
          </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    );
  }
}


const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
});

const mapStateToProps = state => ({
  formState: state.form,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  view: state.viewReducer,
  version: selectedVersion(state),
  selectedContent: getSelectedThinktool(state),
});
const mapDispatchToProps = dispatch => ({
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  resetSaveEditForm: () => dispatch(resetSaveEditForm()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
  versionStatusRequest: () => dispatch(versionStatusRequest()),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
});

export default compose(
  reduxForm({
    form: 'saveEdit',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleSaveEdit: props => values => {
      props.xapiRequest({ xapiType: `Saved`});
      validateSaveEditPassword(values);
      props.saveVersionRequest();
    },
    handleOverwrite: props => () => {
      props.xapiRequest({ xapiType: `Saved`});
      props.overwriteVersionRequest();
    },
    onClearClick: props => () => {
      const { resetPathToSaveVersion, toggleSaveEditPopup } = props;
      props.resetPathToSaveVersion();
      toggleSaveEditPopup(false);
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        toggleNotification,
        toggleSaveEditPopup,
        savedVersions,
        versionStatusRequest,
      } = nextProps;
      
      if (savedVersions.isVersionSaved && !this.props.savedVersions.isVersionSaved && this.props.userProgramsFull.item.type !='Journal') {
        
        toggleNotification({
          value: true,
          message: 'Version was saved successfully',
          type: 'success',
        });
        this.props.resetPathToSaveVersion();
        toggleSaveEditPopup(false);
        versionStatusRequest();
      }
      if (savedVersions.isOverwriteVersion && !this.props.savedVersions.isOverwriteVersion && this.props.userProgramsFull.item.type !='Journal') {
        
        toggleNotification({
          value: true,
          message: 'Version was overwritten successfully',
          type: 'success',
        });
        this.props.resetPathToSaveVersion();
        toggleSaveEditPopup(false);
        versionStatusRequest();
      }
    },
  }),
  withStyles(styles),
)(SaveEditPopup);

SaveEditPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  savedVersions: PropTypes.instanceOf(Object),
  userProgramsFull: PropTypes.instanceOf(Object),
  handleOverwrite: PropTypes.func,
};
